"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    drawerLinks: [
        {
            label: "Home",
            url: "/",
        },
        {
            label: "My FF",
            url: "/us/MyFF",
        },
        {
            label: "FF 91",
            url: "/us/ff-91",
            subnav: [
                {
                    label: "FF 91 Futurist",
                    url: "/us/ff-91"
                },
                {
                    label: "Configure",
                    url: "/us/design"
                },
                {
                    label: "Demo Drive",
                    url: "/us/event/demo-drive"
                },
            ]
        },
        {
            label: "App",
            url: "/us/mobile-app",
        },
        {
            label: "Investors",
            url: "https://investors.ff.com/"
        },
        {
            label: "Press Room",
            url: "/us/press-room"
        },
        {
            label: "Contact Us",
            url: "/us/contact-us"
        },
    ],
    centerLinks: [
        {
            label: "",
            url: "",
        },
        {
            label: "",
            url: "",
        },
    ],
    menubarLinks: [
        {
            label: "FF 91",
            url: "/us/ff-91",
        },
        {
            label: "Configure",
            url: "/us/design",
        },
    ],
    ctaButton: {
        label: 'PREORDER',
        url: '/us/preorder'
    },
    logoLink: "/us",
    colorTheme: "LIGHT",
    scrollEffect: true
};
exports.default = defaultProps;
